// extracted by mini-css-extract-plugin
module.exports = {"starRatingContainer":"star-rating_starRatingContainer__5zyoF"};